<template>
  <Modal
    :value="isShow"
    @on-cancel="hideModal"
    :mask-closable="false"
    width="450"
    class-name="vertical-center-modal login"
  >
    <!-- 标题头 -->
    <div
      slot="header"
      class="login-title"
    >
      <div class="icon-left">
        <img src="@/assets/imgs/login-icon.png" alt="注册">
        <span></span>
        <h3>{{opreateTile}}</h3>
      </div>

      <div class="icon-right" @click="switchLoginType(loginType.goType)">
        {{loginType.title}}
      </div>
    </div>
    <!-- 内容部分 -->
    <div style="text-align:center">
      <Form
        ref="formLogin"
        :model="formModal"
        :rules="formRule"
      >
        <!-- 手机号 -->
        <FormItem prop="phoneNumber">
          <Row :gutter="16">
            <Col span="24">
            <Input
              type="text"
              v-model="formModal.phoneNumber"
              placeholder="请输入手机号"
            >
            <Icon
              type="md-phone-portrait"
              slot="prefix"
            ></Icon>
            </Input>
            </Col>
          </Row>
        </FormItem>

        <!-- 密码 账号注册 和 密码登录 -->
        <FormItem prop="password" v-if="loginType.type === 'password' || loginType.type === 'registered'">
          <Row :gutter="16">
            <Col span="24">
              <Input
                type="password"
                password
                :maxlength="15"
                v-model="formModal.password"
                placeholder="密码(6-15位)"
              >
                <Icon
                  type="ios-lock"
                  slot="prefix"
                ></Icon>
              </Input>
            </Col>
          </Row>
        </FormItem>

        <!-- 验证码 -->
        <FormItem prop="captcha" v-if="loginType.type === 'mobile' || loginType.type === 'registered' || loginType.type === 'forget'">

          <Row :gutter="16">
            <Col span="16">
            <Input
              type="text"
              v-model="formModal.captcha"
              placeholder="请输入校验码"
            >
            <Icon
              type="md-image"
              slot="prefix"
            ></Icon>
            </Input>
            </Col>
            <Col
              span="8"
              class="captcha-wrap"
            >
            <img
              class="captcha-img"
              alt="请求过于频繁"
              @click="getAndResCaptcha"
            >
            </Col>
          </Row>
        </FormItem>

        <!-- 短信验证码 -->
        <FormItem prop="phoneCode" v-if="loginType.type === 'mobile' || loginType.type === 'registered' || loginType.type === 'forget'">

          <Row :gutter="16">
            <Col span="16">
            <Input
              type="text"
              v-model="formModal.phoneCode"
              placeholder="请输入验证码"
            >
            <Icon
              type="md-mail"
              slot="prefix"
            ></Icon>
            </Input>
            </Col>
            <Col span="8">
            <Button
              @click="handleSendCode"
              :disabled="phoneCodebtn"
            >{{ phoneCodeText }}</Button>
            </Col>
          </Row>
        </FormItem>

        <!-- 设置密码 -->
        <FormItem prop="setPwd" v-if="loginType.type=== 'forget'">
          <Row :gutter="16">
            <Col span="24">
            <Input
              type="password"
              password
              :maxlength="15"
              v-model="formModal.setPwd"
              placeholder="请设置密码(6-15位)"
            >
            <Icon
              type="ios-lock"
              slot="prefix"
            ></Icon>
            </Input>
            </Col>
          </Row>
        </FormItem>

        <!-- 再次设置密码 -->
        <FormItem prop="conSetPwd" v-if="loginType.type=== 'forget'">
          <Row :gutter="16">
            <Col span="24">
            <Input
              type="password"
              password
              :maxlength="15"
              v-model="formModal.conSetPwd"
              placeholder="再次输入新密码"
            >
            <Icon
              type="ios-lock"
              slot="prefix"
            ></Icon>
            </Input>
            </Col>
          </Row>
        </FormItem>

      </Form>

      <!-- 协议 -->
      <div class="login-registered" v-if="loginType.type === 'registered'">
        <div class="login-tip">
              点击登录或完成账号注册标识您已阅读并同意
        </div>
        <div class="login-protocol">
          <router-link
            to="/license.html"
            target="_blank"
          >《用户协议》</router-link>和
          <router-link
            to="/privacy_policy.html"
            target="_blank"
          >《隐私政策》</router-link>和
           <router-link
            to="/vod_agreement.html"
            target="_blank"
          >《暴风影音付费服务协议》</router-link>
        </div>
      </div>

    </div>
    <!-- 页脚部分 -->
    <div
      slot="footer"
      class="login-footer"
    >
      <Button
        type="primary"
        size="large"
        shape="circle"
        :loading="modal_loading"
        @click="handleSubmit('formLogin')"
      >
        <span v-if="loginType.type === 'registered'">注册</span>
        <span v-else-if="loginType.type === 'forget'">保存修改</span>
        <span v-else>登录</span>
      </Button>
      <div v-if="loginType.type === 'password'" class="accountOperate">
        <span @click="switchLoginType('registered')">账号注册</span>|
        <span @click="switchLoginType('forget')">忘记密码</span>
      </div>
      <div v-if="loginType.type ===  'mobile'" class="accountOperate">
        <span @click="switchLoginType('registered')">账号注册</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import qs from 'qs'
import apis from '@/assets/js/api'
import cookie from '@/assets/js/cookie'
import { MD5 } from '@/utils/md5'
import { hex_sha1 } from '@/utils/sha1'
import { createNamespacedHelpers } from 'vuex'
import { Encrypt } from '@/utils/crypto'
const { mapActions, mapMutations } = createNamespacedHelpers('common')

export default {
  name: 'Login',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ucid () {
      return MD5('mweb' + new Date().getTime() + apis.poseidonCommonParams.fudid + parseInt(Math.random() * 1000))
    },
    opreateTile () {
      let title = '登录'
      if (this.loginType.type === 'registered') {
        title = '注册'
      } else if (this.loginType.type === 'forget') {
        title = '忘记密码'
      }
      return title
    }
  },
  watch: {
    isShow: function (newIsShow) {
      const login_type = this.loginType.type
      const showCaptcha = login_type === 'mobile' || login_type === 'registered' || login_type === 'forget'
      if (newIsShow && showCaptcha) {
        this.getAndResCaptcha()
      }
    }
  },
  data () {
    return {
      user_key: 'bf_login_user',
      captchaUrl: '', // 图形验证码url
      modal_loading: false,
      phoneCodeText: '获取短信验证码', // 倒计时文本
      timer: null, // 定时器对象
      phoneCodebtn: false, // 验证码发送按钮状态
      isValidCap: false, // 验证码是否是正确的
      captCode: null, // 正确的图形验证码
      isRegisPhone: false, // 手机号是否已经注册
      loginType: {type: 'password', desc: '账号密码登录', title: '手机号快捷登录', goType: 'mobile'}, // 登录方式
      sendKeyType: Object.freeze({
        1: '手机注册',
        2: '手机验证码登录',
        3: '绑定手机号',
        4: '解绑手机号',
        5: '找回密码',
        6: '更换手机号验证老手机号',
        7: '更换手机号验证老手机号',
        8: '第三方账号绑定手机号',
        9: '解绑第三方账号',
        10: '注销账号'
      }),

      formModal: {
        phoneNumber: '', // 手机号
        password: '', // 密码
        captcha: '', // 图形校验码
        setPwd: '', // 设置密码
        conSetPwd: '', // 确认密码
        phoneCode: '' // 手机验证码
      },
      formRule: {
        // 手机号
        phoneNumber: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        // 密码 / 设置密码
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { pattern: /^.{6,15}$/, message: '密码长度不正确', trigger: 'blur' }
        ],
        captcha: [{ vrequired: true, validator: this.validatecaptcha, trigger: 'blur' }],
        phoneCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '短信验证码错误', trigger: 'blur' }
        ],
        setPwd: [
          { required: true, validator: this.pwdCheck, trigger: 'blur' }
        ],
        conSetPwd: [
          { required: true, validator: this.pwdAgainCheck, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.readyLoginUpdate()
  },
  methods: {
    ...mapActions(['testCaptcha', 'sendPhoneCode', 'handleLogin', 'pwdLogin', 'phoneRegister', 'getUserData', 'userIsRegister', 'getPhoneKey', 'resetPassword']),
    ...mapMutations(['syncProfile']),

    // 获取图形验证码
    getAndResCaptcha () {
      const ctime = Math.floor(new Date().valueOf() / 1000)
      const params = { ucid: this.ucid, ...apis.poseidonCommonParams, ctime }
      this.captchaUrl = 'http://pcap.funshion.com/v1/cap/captcha?' + qs.stringify(params)
      document.getElementsByClassName('captcha-img')[0].setAttribute('src', this.captchaUrl)
      this.captCode = null
    },

    // 图形验证码异步认证
    async validatecaptcha (rule, value, callback) {
      if (!value) {
        this.isValidCap = false
        return callback(new Error('图形验证码不能为空'))
      }

      if (this.formModal.captcha.length != 4) {
        this.isValidCap = false
        return callback(new Error('图形验证码错误'))
      }
      // 如果值相等 不校验
      if (value == this.captCode) {
        this.isValidCap = true
        return callback()
      }
      let param = {
        ucid: this.ucid,
        captcha: this.formModal.captcha,
        ...apis.poseidonCommonParams
      }
      try {
        await this.testCaptcha(param)
        this.isValidCap = true // 验证码输入正确
        this.captCode = this.formModal.captcha // 正确的图形验证码
        return callback()
      } catch (e) {
        this.isValidCap = false
        return callback(new Error('图形验证码错误'))
      }
    },

    // 验证手机号
    vaildPhoneNum (rule, value, callback) {
      let param = {
        encry_user_name: Encrypt(this.formModal.phoneNumber),
        ...apis.getPuParams()
      }
      if (!this.isRegisPhone) {
        this.userIsRegister(param).then((res) => {
          this.isRegisPhone = true
          return callback()
        }).catch((err) => {
          this.isRegisPhone = false
          if (err['code'] == 401) {
            return callback(new Error('该手机已经被注册'))
          } else {
            return callback(new Error('isavailable api调用出错'))
          }
        })
      } else {
        return callback()
      }
    },

    // 密码验证
    async pwdCheck (rule, value, callback) {
      let reg = /^.{6,15}$/
      if (value.length < 6) {
        return callback(new Error('密码不能少于6位'))
      } else if (value.length > 16) {
        return callback(new Error('密码最长不能超过15位'))
      } else if (!reg.test(value)) {
        return callback(new Error('密码输入有误，请检查格式是否正确'))
      } else {
        callback()
      }
    },

    // 再次确认验证码
    async pwdAgainCheck (rule, value, callback) {
      if (value.length < 1) {
        return callback(new Error('确认密码不能为空'))
      } else if (this.formModal.setPwd != this.formModal.conSetPwd) {
        return callback(new Error('两次输入的密码不匹配'))
      } else {
        callback()
      }
    },

    // 发送手机验证码 (保证手机号和图形验证码正确)
    handleSendCode () {
      const { phoneNumber, captcha } = this.formModal
      const encryptNumber = Encrypt(phoneNumber)
      this.$refs['formLogin'].validateField('phoneNumber', (vaild1) => {
        // 手机号 和图形验证码 必须通过验证
        if (!vaild1) {
          // 代表图形验证码通过验证
          if (this.isValidCap) {
            const { type } = this.loginType
            let postMsgType = 2
            if (type === 'mobile') { // 手机号快捷登录
              postMsgType = 2
            } else if (type === 'forget') {
              postMsgType = 5
            } else if (type === 'registered') {
              postMsgType = 1
            } else {
              postMsgType = 2
            }
            const sendParams = {
              captcha: captcha,
              encry_phone: encryptNumber,
              ucid: this.ucid,
              type: postMsgType,
              content: `尊敬的用户，您正在进行${this.sendKeyType[postMsgType]}操作，验证码为：%verifycode%，有效期30分钟，如非本人操作请忽略此短信。`
            }
            const param = { ...sendParams, ...apis.poseidonCommonParamsNew }
            this.phoneCodebtn = true
            this.sendPhoneCode(param).then(() => {
              this.countDown()
            }).catch(() => {
              this.phoneCodebtn = false
            // this.getAndResCaptcha()
            })
          } else {
            if (this.formModal.captcha.length < 1) {
              this.$refs['formLogin'].validateField('captcha')
            }
          }
        }
      })
    },

    // 倒计时
    countDown () {
      let time = 60
      this.phoneCodeText = time + 's后重新获取'
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        time--
        this.phoneCodeText = time + 's后重新获取'
        if (time == 0) {
          clearInterval(this.timer)
          this.timer = null
          this.phoneCodeText = '获取验证码'
          this.phoneCodebtn = false
        }
      }, 1000)
    },

    encodePassword (password) {
      return hex_sha1(password).substr(0, 15)
    },

    // 登录按钮
    handleSubmit (name) {
      const loginType = this.loginType.type
      console.log('提交的类型===========>', loginType)
      if (loginType === 'password') { // 密码登录
        this.loginPwd(name)
      } else if (loginType === 'mobile') { // 手机号登录
        this.loginMobile(name)
      } else if (loginType === 'registered') { // 注册手机号
        this.loginRegister(name)
      } else { // 忘记密码
        this.loginForget(name)
      }
    },

    // 密码登录 over
    loginPwd (name) {
      this.$refs[name].validate().then(res => {
        if (res) {
          const baseParams = apis.getPuParams()
          const { phoneNumber, password } = this.formModal
          const params = {
            encry_un: Encrypt(phoneNumber), // 手机号
            pd: MD5(this.encodePassword(password) + baseParams.timestamp),
            ...baseParams
          }
          this.pwdLogin(params).then(res => {
            this.loginSuccess(res)
          }).catch(() => {
            this.modal_loading = false
          })
        }
      })
    },

    // 手机号登录 over
    loginMobile (name) {
      // 手机号登录
      this.$refs[name].validate().then(res => {
        if (res) {
          const { phoneNumber, phoneCode } = this.formModal
          const params = {
            encry_phone: Encrypt(phoneNumber),
            code: phoneCode,
            ...apis.getPuParams()
          }
          // 登录接口 开始登录
          console.log('手机号登录=========>', params)
          this.handleLogin(params).then(res => {
            this.loginSuccess(res)
          }).catch(() => {
            this.modal_loading = false
          })
        }
      })
    },

    // 注册
    loginRegister (name) {
      this.$refs[name].validate().then(res => {
        if (res) {
          const { phoneNumber, password, phoneCode } = this.formModal
          const params = {
            encry_un: Encrypt(phoneNumber),
            pd: this.encodePassword(password), // 密码
            code: phoneCode, // 短信验证码
            ...apis.getPuParams()
          }
          console.log('注册的行号参数', params)
          this.phoneRegister(params).then(res => {
            this.loginSuccess(res)
          }).catch(() => {
            this.modal_loading = false
          })
        }
      })
    },

    // 忘记密码 this.getPhoneKey =====> this.resetPassword
    loginForget (name) {
      this.$refs[name].validate().then(async res => {
        if (res) {
          const { phoneNumber, phoneCode, conSetPwd } = this.formModal
          const params1 = {
            encry_phone: Encrypt(phoneNumber),
            code: phoneCode, // 短信验证码
            ...apis.getPuParams()
          }
          try {
            const {user_name, key} = await this.getPhoneKey(params1)
            const encodePassword = this.encodePassword(conSetPwd)
            const params2 = {un: user_name, pd: encodePassword, key, ...apis.getPuParams()}
            // 重置密码接口
            const result = await this.resetPassword(params2)
            if (result.msg === 'ok') {
              this.$Message.success({content: '重置密码成功', duration: 3})
            }
            // 跳转到账号密码登录页
            this.loginType = {
              type: 'password',
              desc: '账号密码登录',
              title: '手机号快捷登录',
              goType: 'mobile'
            }
          } catch (e) {
            console.warn('出错了====>', e)
          }
        }
      })
    },

    // 登录成功 回调
    loginSuccess (result) {
      this.modal_loading = false
      const { user_name, user_id, token } = result
      const param = {user_name, user_id, token}
      cookie.set(this.user_key, JSON.stringify(param), 1)
      this.$Message.success({content: '登录成功', duration: 3})
      if (this.$route.query.open) {
        this.$router.replace('/')
      }
      // 登录成功 关闭模态框
      this.hideModal()
      // 获取用户基本信息
      this.getUserInfo(param)
    },

    /* 获取用户信息 */
    getUserInfo (option, where) {
      const paylaod = {
        userinfo: Object.assign({}, option, apis.poseidonCommonParams),
        getuserinfo: Object.assign({}, option, apis.poseidonCommonParamsNew)
      }
      this.getUserData(paylaod).then((result) => {
        // console.log('获取用的基本信息和vip付费信息', result)
        let userinfoCookie = {}
        if (cookie.get(this.user_key)) {
          userinfoCookie = JSON.parse(cookie.get(this.user_key))
        }
        let [vipinfo, baseinfo] = result
        let userInfo = {
          uservipinfo: vipinfo.data,
          userbaseinfo: baseinfo
        }
        if (!userInfo.uservipinfo && !userInfo.userbaseinfo.userId) {
          console.log('获取的用户信息存在问题 更新用户信息==>')
          this.updateLoginInfo()
        }

        let userCookie = Object.assign({}, userinfoCookie, userInfo)
        let $cookie = cookie.format(userCookie)
        this.cookieDiff($cookie) // 更新cookie
        // 通知个人交易中心 更新信息
        if (where && where === 'bySuccess') {
          this.syncProfile(true)
        }
      }).catch(err => {
        console.log('获取用的基本信息和vip付费信息出现问题==>', err)
      })
    },

    // 更新cookie信息
    cookieDiff (data) {
      // console.log('cookie diff==', data)
      this.userId = data.user_id
      if (cookie.get(this.user_key) && cookie.get(this.user_key) != 'undefined') { // 存在用户cookie信息
        var info = JSON.parse(cookie.get(this.user_key))
        // console.log('cookie diff user==', info)
        // user_id 不同 或是 isvip状态不同 则更新cookie
        if (!info.uservipinfo) {
          // 首次登陆 没有vip信息
          cookie.set(this.user_key, JSON.stringify(data), 1)
          this.updateLoginInfo()
          return
        }
        if (info.user_id != data.user_id || info.uservipinfo.is_vip != data.uservipinfo.is_vip || info.uservipinfo.endtm != data.uservipinfo.endtm || info.token != data.token) {
          // console.log('cookie diff')
          cookie.set(this.user_key, JSON.stringify(data), 1)
          this.updateLoginInfo()
        }
      } else { // 不存在用户信息
        // console.log('cookie diff no user')
        cookie.set(this.user_key, JSON.stringify(data), 1)
        this.updateLoginInfo()
      }
    },

    // 同步更新用户信息 通知父组件
    updateLoginInfo () {
      this.$emit('updateLoginStatus')
    },

    // 已经登录 获取用户基本信息
    readyLoginUpdate (msg) {
      const getLogin = cookie.get(this.user_key)
      if (getLogin) {
        const info = JSON.parse(getLogin)
        const param = {
          user_name: info.user_name,
          user_id: info.user_id,
          token: info.token
        }
        this.getUserInfo(param, msg)
      }
    },

    // 关闭模态框
    hideModal () {
      this.$refs['formLogin'].resetFields()
      this.$emit('hideModal')
      // 关闭后再次打开 默认是 账号密码登录
      this.switchLoginType('password')
      // 清空定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.phoneCodeText = '获取验证码'
        this.phoneCodebtn = false
      }
    },

    switchLoginType (type) {
      // 清空表单验证
      this.$refs['formLogin'].resetFields()
      if (type === 'registered') {
        // 给手机号添加异步验证器
        this.formRule.phoneNumber.push({
          validator: this.vaildPhoneNum,
          trigger: 'blur'
        })
      } else {
        this.formRule.phoneNumber.forEach((item, idx, arr) => {
          if (item['validator']) {
            arr.splice(idx, 1)
          }
        })
      }
      // 重置状态
      this.isValidCap = false
      this.isRegisPhone = false
      let desc = '', title = '', goType = ''
      if (type === 'password') { // 账号密码登录
        desc = '账号密码登录'
        title = '手机号快捷登录'
        goType = 'mobile'
      } else if (type === 'mobile') { // 手机号快捷登录
        desc = '手机号登录'
        title = '账号密码登录'
        goType = 'password'
      } else if (type === 'forget') { // 忘记密码
        desc = '忘记密码'
        title = '账号密码登录'
        goType = 'password'
      } else if (type === 'registered') { // 注册账号
        desc = '注册账号'
        title = '手机号快捷登录'
        goType = 'mobile'
      } else {
        desc = '账号密码登录'
        title = '手机号快捷登录'
        goType = 'mobile'
      }
      this.loginType = {type, desc, title, goType}

      if (this.loginType.type === 'mobile' || this.loginType.type === 'registered' || this.loginType.type === 'forget') {
        this.$nextTick(() => { // 获取图形验证码
          this.getAndResCaptcha()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login-title {
  color: #fff;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon-left{
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #0184FF;
    span{
      display: block;
      width:10px;
      height: 10px;
      border-radius: 5px;
      background: #0184FF;
      margin: 0 10px;
    }
    h3{
      font-size: 25px;
    }
  }

  .icon-right{
    margin-right: 35px;
    font-size: 14px;
    color: #D8D8D8;
    margin-top: 5px;
    cursor: pointer;
  }
}
.login-footer {
  text-align: center;
  button {
    width: 230px;
  }

  .accountOperate{
    font-size: 14px;
    margin-top: 10px;
    color: #16161C;
    span{
      margin: 10px;
      cursor: pointer;
    }
  }
}
.login-protocol {
  a {
    color: #2d8cf0 !important;
  }
}
.captcha-wrap {
  position: relative;
  .captcha-img {
    height: 30px;
    position: absolute;
    top: 2px;
    left: 30px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue